import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.scss']
})
export class PromptDialogComponent
{
  form: FormGroup;
  showError: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PromptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  )
  {
    this.form = this.fb.group({
      inputField: ['', Validators.required]
    });

    this.dialogRef.beforeClosed().subscribe(() =>
    {
      if (!this.form.valid)
      {
        this.showError = true;
        this.form.controls['inputField'].markAsTouched();
        return false;
      }
    });
  }

  handleDoneClick(): void
  {
    if (this.form.valid)
    {
      this.dialogRef.close(this.form.value.inputField);
    }
    else
    {
      this.showError = true;
      this.form.controls['inputField'].markAsTouched();
    }
  }

  handleCancelClick(): void
  {
    this.dialogRef.close(null);
  }
}
